var map = {
	"./datasets/common/inputs.json": [
		835,
		835
	],
	"./images/common/placeholder-8x1.png": [
		452,
		452
	],
	"./images/demo/TutoHide.png": [
		8423,
		8423
	],
	"./images/demo/bg-tree.png": [
		8055,
		8055
	],
	"./images/demo/bg.png": [
		7298,
		7298
	],
	"./images/demo/bush.png": [
		3492,
		3492
	],
	"./images/demo/checkpoint.png": [
		3614,
		3614
	],
	"./images/demo/discover.png": [
		7844,
		7844
	],
	"./images/demo/ennemy-idle-left.png": [
		6511,
		6511
	],
	"./images/demo/ennemy-idle-right.png": [
		1317,
		1317
	],
	"./images/demo/ennemy-walk-left.png": [
		6403,
		6403
	],
	"./images/demo/ennemy-walk-right.png": [
		8491,
		8491
	],
	"./images/demo/light-left.png": [
		3896,
		3896
	],
	"./images/demo/light-right.png": [
		8210,
		8210
	],
	"./images/demo/moon.png": [
		96,
		96
	],
	"./images/demo/perso-die.png": [
		493,
		493
	],
	"./images/demo/perso-idle-left.png": [
		3347,
		3347
	],
	"./images/demo/perso-idle-right.png": [
		9410,
		9410
	],
	"./images/demo/perso-walk-left.png": [
		1962,
		1962
	],
	"./images/demo/perso-walk-right.png": [
		5550,
		5550
	],
	"./images/demo/placeholder-8x1.png": [
		3794,
		3794
	],
	"./images/demo/spike.png": [
		1396,
		1396
	],
	"./images/demo/tilesets-old.png": [
		3977,
		3977
	],
	"./images/demo/tilesets.png": [
		3856,
		3856
	],
	"./images/demo/tuto-move.png": [
		6649,
		6649
	],
	"./sounds/demo/backtrack.mp3": [
		979,
		979
	],
	"./sounds/demo/chocko0.mp3": [
		6545,
		6545
	],
	"./sounds/demo/chocko1.mp3": [
		7590,
		7590
	],
	"./sounds/demo/chocko2.mp3": [
		8052,
		8052
	],
	"./sounds/demo/die0.mp3": [
		4699,
		4699
	],
	"./sounds/demo/die1.mp3": [
		9854,
		9854
	],
	"./sounds/demo/jump0.mp3": [
		3400,
		3400
	],
	"./sounds/demo/spike.mp3": [
		159,
		159
	],
	"./sprites/demo/TutoHide.json": [
		9640,
		9640
	],
	"./sprites/demo/bg-tree.json": [
		5631,
		5631
	],
	"./sprites/demo/bg.json": [
		767,
		767
	],
	"./sprites/demo/bush.json": [
		1813,
		1813
	],
	"./sprites/demo/checkpoint.json": [
		1211,
		1211
	],
	"./sprites/demo/discover.json": [
		6724,
		6724
	],
	"./sprites/demo/ennemy-idle-left.json": [
		4960,
		4960
	],
	"./sprites/demo/ennemy-idle-right.json": [
		7611,
		7611
	],
	"./sprites/demo/ennemy-walk-left.json": [
		2407,
		2407
	],
	"./sprites/demo/ennemy-walk-right.json": [
		1867,
		1867
	],
	"./sprites/demo/light-left.json": [
		6130,
		6130
	],
	"./sprites/demo/light-right.json": [
		1765,
		1765
	],
	"./sprites/demo/moon.json": [
		4999,
		4999
	],
	"./sprites/demo/perso-die.json": [
		6606,
		6606
	],
	"./sprites/demo/perso-idle-left.json": [
		6969,
		6969
	],
	"./sprites/demo/perso-idle-right.json": [
		4345,
		4345
	],
	"./sprites/demo/perso-walk-left.json": [
		9419,
		9419
	],
	"./sprites/demo/perso-walk-right.json": [
		484,
		484
	],
	"./sprites/demo/spike.json": [
		8641,
		8641
	],
	"./sprites/demo/tilesets.json": [
		8993,
		8993
	],
	"./sprites/demo/tuto-move.json": [
		6628,
		6628
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => Object.keys(map);
webpackAsyncContext.id = 451;
module.exports = webpackAsyncContext;